import { afterFilterApiFetched } from "@modules/azm/after-filter-api-fetched"
import { fetchApiWithAllFilters } from "@modules/azm/api"
import { rerenderTrafficStarsBeforePagination } from "@modules/azm/traffic-stars"
import { dispatchGlobalEvent } from "@modules/util/events"
import { LogLevel, log } from "@modules/util/logger"
import { advertCardsContainerElement } from "../../global/dom"
import { updateAffiliateAdvertsInDom } from "../affiliates"
import {
    disableAllPaginationElements,
    getNextPage,
    getPage,
    getPreviousPageToLoad,
    setNextPage,
    setPage,
    setPreviousPage,
} from "../pagination/pagination"
import { rerenderSoladsBeforePagination } from "../solads"

export async function onPaginationButtonClick(element: HTMLElement | null, clickFunction: () => Promise<void>) {
    element?.setAttribute("loading", "")
    disableAllPaginationElements()
    try {
        await clickFunction()
    } catch (e: any) {
        log(LogLevel.ERROR, e)
    }

    element?.removeAttribute("loading")
}

export async function onPreviousClickPc() {
    setPage(getPage() - 1)
    await afterFilterApiFetched(await fetchApiWithAllFilters())

    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("azm.pagination.change", {
        page: getPage(),
    })
    updateAffiliateAdvertsInDom()
}

export async function onPreviousClickMobile() {
    setPage(getPreviousPageToLoad())
    setPreviousPage(getPreviousPageToLoad() - 1)

    const firstCardElement = advertCardsContainerElement()?.querySelector(".ladies-card")
    await afterFilterApiFetched(await fetchApiWithAllFilters(), {
        insertAdjacentHTML: "afterbegin",
    })

    firstCardElement?.scrollIntoView()
    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("azm.pagination.change", {
        page: getPage(),
    })
    updateAffiliateAdvertsInDom()
}

export async function onNextClickPc() {
    setPage(getPage() + 1)
    await afterFilterApiFetched(await fetchApiWithAllFilters())

    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("azm.pagination.change", {
        page: getPage(),
    })
    updateAffiliateAdvertsInDom()
}

export async function onNextClickMobile() {
    setPage(getNextPage())
    setNextPage(getNextPage() + 1)

    await afterFilterApiFetched(await fetchApiWithAllFilters(), {
        insertAdjacentHTML: "beforeend",
    })

    rerenderSoladsBeforePagination()
    rerenderTrafficStarsBeforePagination()

    dispatchGlobalEvent("azm.pagination.change", {
        page: getPage(),
    })
    updateAffiliateAdvertsInDom()
}
